"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeClient = exports.graphGatewayURL = exports.AMPLEFORTH_DAO_SUBGRAPH_ID = exports.graphHostedURL = exports.GRAPH_ENDPOINTS = exports.GRAPH_BASE_URL = exports.GRAPH_GATEWAY_URL = exports.MAX_PER_PAGE = void 0;
const core_1 = require("@urql/core");
const isomorphic_unfetch_1 = __importDefault(require("isomorphic-unfetch"));
exports.MAX_PER_PAGE = 500;
exports.GRAPH_GATEWAY_URL = 'https://gateway.thegraph.com';
exports.GRAPH_BASE_URL = 'https://api.thegraph.com/subgraphs/name';
exports.GRAPH_ENDPOINTS = {
    // chainID => endpoint
    1: `https://web-api.ampleforth.org/graph-cache/ampleforth-core`,
    5: `${exports.GRAPH_BASE_URL}/ampleforth/ampleforth-core-goerli`,
    43114: `${exports.GRAPH_BASE_URL}/ampleforth/ampleforth-core-avalanche`,
};
const graphHostedURL = (chainID = 1) => {
    return exports.GRAPH_ENDPOINTS[chainID];
};
exports.graphHostedURL = graphHostedURL;
exports.AMPLEFORTH_DAO_SUBGRAPH_ID = '3KgoMxpMHJsLK2R4W9hrF6S7WTYdcH9UW9vtnsGumY4s';
const graphGatewayURL = (apiKey) => {
    return `${exports.GRAPH_GATEWAY_URL}/api/${apiKey}/subgraphs/id/${exports.AMPLEFORTH_DAO_SUBGRAPH_ID}`;
};
exports.graphGatewayURL = graphGatewayURL;
const initializeClient = (url) => {
    return new core_1.Client({
        fetch: isomorphic_unfetch_1.default,
        url,
        exchanges: [core_1.cacheExchange, core_1.fetchExchange],
    });
};
exports.initializeClient = initializeClient;
//# sourceMappingURL=client.js.map